module.exports = __webpack_public_path__ + "img/ios.c7e76d6a.png";